import {Component, effect, inject, input, signal} from '@angular/core';
import {DataSubscriptionService} from "src/app/infrastructure/data-subscription.service";
import {
  PrecipitationSvgComponent
} from "src/app/presentation/common/icons/precipitation-svg/precipitation-svg.component";
import {DataSynchronisationService} from "src/app/infrastructure/data-synchronisation.service";
import {ViewportService} from "src/app/infrastructure/viewport.service";
import {FixedSamplePoint, SynchronizationStatus} from "src/app/infrastructure/moovement-api/models/asset";
import {FixedSamplePointsStore} from 'src/app/domain/assets/fixed-sample-points/fixed-sample-points.store';
import {AggregatedAssetStateStore} from 'src/app/domain/assets/aggregated-state/aggregated-asset-state.store';
import {Router} from '@angular/router';
import {timeAgo} from 'src/app/domain/util/timestamps/timestamps';
import {isEqualToOrYoungerThanOffset} from 'src/app/app.config';
import {oneHour} from 'src/app/presentation/common/globals';

@Component({
  selector: 'app-precipitation-point-button',
  imports: [
    PrecipitationSvgComponent
  ],
  templateUrl: './precipitation-point-button.component.html',
  styleUrl: './precipitation-point-button.component.css'
})
export class PrecipitationPointButtonComponent {

  id = input.required<string>();

  precipitationSamplePoint = signal<FixedSamplePoint | undefined>(undefined);
  statusMessage = signal('Last seen: ?');
  statusMessageColorClass = signal('color-danger');

  SynchronizationStatus = SynchronizationStatus;

  private aggregatedAssetStateStore = inject(AggregatedAssetStateStore);
  private fixedSamplePointsStore = inject(FixedSamplePointsStore);
  private router = inject(Router);

  constructor(dataSynchronisationService: DataSynchronisationService, dataSubscriptionService: DataSubscriptionService, viewportService: ViewportService) {
    effect(() => {
      const assetId = this.id();
      if (!assetId) return;

      this.precipitationSamplePoint.set(this.fixedSamplePointsStore.entityMap()[assetId]);
    });

    effect(() => {
      const aggregatedState = this.aggregatedAssetStateStore.entityMap()[this.id()];
      if (!aggregatedState) return;

      const lastSeenByGatewayAt = aggregatedState.lastSeenByGatewayAt;
      this.statusMessage.set(`Last seen: ${timeAgo(lastSeenByGatewayAt)}`);
      const isSeenWithinThreshold = lastSeenByGatewayAt !== undefined && isEqualToOrYoungerThanOffset(lastSeenByGatewayAt, oneHour);
      if (isSeenWithinThreshold) {
        this.statusMessageColorClass.set("color-primary-information");
      } else {
        this.statusMessageColorClass.set("color-danger");
      }
    });
  }

  focus() {
    this.router.navigate(['/main/precipitation-sample-point-details', this.id()]);
  }
}
